"use client";

import { LocaleProvider } from "@/components/i18n/locale-context";

export function AuthLocaleRoot({ children }: { children: React.ReactNode }) {
  return (
    <LocaleProvider initialLocale={null} persistToProfile={false}>
      {children}
    </LocaleProvider>
  );
}
